export enum RoutePath {
  ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_FIELDS = 'ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_FIELDS',
  ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_USER = 'ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_USER',
  ACCOUNT_ONBOARDING_INTEGRATION_PROGRESS = 'ACCOUNT_ONBOARDING_INTEGRATION_PROGRESS',
  ACCOUNT_ONBOARDING_MS365_INTEGRATION = 'ACCOUNT_ONBOARDING_MS365_INTEGRATION',
  ACCOUNT_ONBOARDING_PLAN_ONBOARDING = 'ACCOUNT_ONBOARDING_PLAN_ONBOARDING',
  ACCOUNT_ONBOARDING_PLAN_ONBOARDING_STEP_TWO = 'ACCOUNT_ONBOARDING_PLAN_ONBOARDING_STEP_TWO',
  ADMIN_365_SETUP = 'ADMIN_365_SETUP',
  BENCHMARKING_MSP_BENCHMARKS = 'benchmarkingMspBenchmarks',
  SETTINGS_INTEGRATION_365_AUTH = 'SETTINGS_INTEGRATION_365_AUTH',
  SETTINGS_IMPORT_CONTACTS = 'SETTINGS_IMPORT_CONTACTS',
  SETTINGS_IMPORT_CONTACTS_INITIALSTEP = 'SETTINGS_IMPORT_CONTACTS_INITIALSTEP',
  SETTING_BILLING_SUBSCRIBE = 'SETTING_BILLING_SUBSCRIBE',
  SETTING_BILLING_UPDATE = 'SETTING_BILLING_UPDATE',
  SETTING_COMMUNICATION_PREFERENCES = 'SETTING_COMMUNICATION_PREFERENCES',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_DONE = 'CHANGE_PASSWORD_DONE',
  GET_IN_TOUCH = 'GET_IN_TOUCH',
  GET_IN_TOUCH_DONE = 'GET_IN_TOUCH_DONE',
  ACTIVITY_MAP = 'ACTIVITY_MAP',
  COVERAGE = 'COVERAGE',
  HOME = 'home',
  ENGAGEMENT_SUMMARY = 'engagementSummary',
  ENGAGEMENT_SUMMARY_USER_ID = 'engagementSummaryUserId',
  SEGMENTS = 'segments',
  MEETING_PLANNER = 'meetingPlanner',
  TEAM_ACTIVITY = 'teamActivity',
  USER_ACTIVITY = 'USER_ACTIVITY',
  USER_ACTIVITY_ID = 'myActivity',
  COLOR_SPACE_TOOL = 'COLOR_SPACE_TOOL',
  COMPANIES = 'companies',
  COMPANY = 'COMPANY',
  COMPANY_CONTACTS = 'COMPANY_CONTACTS',
  COMPANY_CONTRACTS = 'COMPANY_CONTRACTS',
  COMPANY_INTERACTION = 'COMPANY_INTERACTION',
  COMPANY_INTERACTIONS = 'COMPANY_INTERACTIONS',
  COMPANY_INTERACTIONS_LOGCALL = 'COMPANY_INTERACTIONS_LOGCALL',
  COMPANY_INTERACTIONS_LOGMEETING = 'COMPANY_INTERACTIONS_LOGMEETING',
  COMPANY_INTERACTIONS_LOGEMAIL = 'COMPANY_INTERACTIONS_LOGEMAIL',
  COMPANY_INTERACTIONS_LOGCOMPANYNOTE = 'COMPANY_INTERACTIONS_LOGCOMPANYNOTE',
  COMPANY_PLANNING = 'COMPANY_PLANNING',
  COMPANY_PLANNING_INTERACTION = 'COMPANY_PLANNING_INTERACTION',
  COMPANY_PROFILE = 'COMPANY_PROFILE',
  COMPANY_FILES = 'COMPANY_FILES',
  COMPANY_NEWS = 'COMPANY_NEWS',
  COMPANY_REVENUE_HISTORY = 'companyRevenueHistory',
  COMPANY_PROFITABILITY = 'companyProfitability',
  COMPANY_PROFITABILITY_CUMULATIVE = 'companyProfitabilityCumulative',
  COMPANY_MEETING_PLANNER = 'companyMeetingPlanner',
  CONTACTS = 'contacts',
  CONTACT = 'CONTACT',
  CONTACT_INTERACTION = 'CONTACT_INTERACTION',
  CONTACT_INTERACTIONS = 'CONTACT_INTERACTIONS',
  CONTACT_SUGGESTED = 'CONTACT_SUGGESTED',
  CONTACT_FILES = 'CONTACT_FILES',
  CONTACT_PROFILE = 'CONTACT_PROFILE',

  OFFICE365_AUTH_COMPLETE = 'OFFICE365_AUTH_COMPLETE',
  OFFICE365_CONSENT_COMPLETE = 'OFFICE365_CONSENT_COMPLETE',
  ONBOARDING_INVITE = 'ONBOARDING_INVITE',
  ONBOARDING_CONFIRM = 'ONBOARDING_CONFIRM',
  ONBOARDING_REGISTER = 'ONBOARDING_REGISTER',
  ONBOARDING_REGISTER_ACTIVATE = 'ONBOARDING_REGISTER_ACTIVATE',
  ONBOARDING_DOWNLOAD = 'ONBOARDING_DOWNLOAD',
  ONBOARDING_EXPIRED = 'ONBOARDING_EXPIRED',
  ONBOARDING_EXISTS = 'ONBOARDING_EXISTS',
  ONBOARDING_READY = 'ONBOARDING_READY',
  ONBOARDING_INTEGRATION = 'ONBOARDING_INTEGRATION',
  ONBOARDING_INTEGRATION_OTHER = 'ONBOARDING_INTEGRATION_OTHER',
  ONBOARDING_INTEGRATION_OFFICE365_AUTH = 'ONBOARDING_INTEGRATION_OFFICE365_AUTH',
  ONBOARDING_INTEGRATION_OFFICE365_AUTH_ID = 'ONBOARDING_INTEGRATION_OFFICE365_AUTH_ID',
  ONBOARDING_CONNECTWISE = 'ONBOARDING_CONNECTWISE',

  PROFITABILITY = 'PROFITABILITY',
  PROFITABILITY_ACCOUNT = 'profitabilityAccount',
  PROFITABILITY_CUSTOMER = 'profitabilityCustomer',
  PROSPECTING = 'PROSPECTING',
  PROSPECTING_BUILD = 'findOpportunities',
  PROSPECTING_ALL_OPPORTUNITIES = 'allOpportunities',
  PROSPECTING_OPEN_OPPORTUNITIES = 'openOpportunities',
  PROSPECTING_SALES_DASHBOARD = 'salesDashboard',
  PROSPECTING_CONTRACT_TRACKER = 'contractTracker',
  REMINDERS = 'REMINDERS',
  REMINDERS_ARCHIVED = 'REMINDERS_ARCHIVED',
  SETTINGS = 'SETTINGS',
  SETTING_ACCOUNT_CURRENCY = 'SETTING_ACCOUNT_CURRENCY',
  SETTING_ACCOUNT_VISIBILITY = 'SETTING_ACCOUNT_VISIBILITY',
  SETTING_AGREEMENT_TYPE_INCLUSIONS = 'settingAgreementTypeInclusions',
  SETTING_ASSIGNED_ACCOUNTS = 'assignedAccounts',
  SETTING_BILLING = 'SETTING_BILLING',
  SETTING_COMPANY_USER_MAPPING = 'SETTING_COMPANY_USER_MAPPING',
  SETTING_FEATURE_SELECTION = 'SETTING_FEATURE_SELECTION',
  SETTING_FIELDS = 'SETTING_FIELDS',
  SETTING_FIELDS_COMPANY = 'SETTING_FIELDS_COMPANY',
  SETTING_FIELDS_CONTACTS = 'SETTING_FIELDS_CONTACTS',
  SETTING_FILE_SHARE = 'SETTING_FILE_SHARE',
  SETTING_IMPORT = 'SETTING_IMPORT',
  SETTING_INVOICES = 'SETTING_INVOICES',
  SETTING_MEETING_PLANNER_TIERS = 'SETTING_MEETING_PLANNER_TIERS',
  SETTING_O365 = 'SETTING_O365',
  SETTING_PRODUCT_STACK_SETUP = 'SETTING_PRODUCT_STACK_SETUP',
  SETTING_PSA_INTEGRATION = 'SETTING_PSA_INTEGRATION',
  SETTING_RECURRING_MEETINGS = 'SETTING_RECURRING_MEETINGS',
  SETTING_SCORING = 'SETTING_SCORING',
  SETTING_TEAMS_CALLING = 'SETTING_TEAMS_CALLING',
  SETTING_USER = 'SETTING_USER',
  SETTING_USERS = 'SETTING_USERS',
  TIERING = 'TIERING',
  TIERING_CUSTOMER = 'customerTiering',
  TRACK_REVENUE = 'trackRevenue',
  TRACK_REVENUE_OVER_TIME = 'agreementRevenueTotalRevenueTrend',
  TRACK_REVENUE_CHANGE_OVER_TIME = 'agreementRevenueRevenueChange',
  TRACK_REVENUE_BY_PRODUCT = 'agreementRevenueProductGrowth',
  TRACK_REVENUE_BY_CUSTOMER = 'agreementRevenueCustomerGrowth',
  WHITESPACE = 'WHITESPACE',
  WHITESPACE_ADDITIONS_OVERVIEW = 'productPenetrationOverview',
  WHITESPACE_AGREEMENT_ADDITION_MAP = 'whitespaceAgreementAdditionMapping',
  WHITESPACE_AGREEMENT_TYPE = 'whitespaceAgreementTypes',
  WHITESPACE_PRODUCT_ADDITIONS = 'whitespaceProductAdditions',
}
